import { Navigate } from "react-router-dom";

export default function IndexView() {
  return <Navigate to="/command" replace />;
}
